<div class="main-container">
  <div class="afiliaciones-content row">

    <h1>Consultar autorizaciones</h1>
    <span style="font-size: medium; color: var(--mid-gray-color)">
      Ingrese los datos en los campos de búsqueda para realizar el seguimiento de
      las solicitudes de autorización radicadas en su población
    </span>

    <br /><br /><br />

    <form [formGroup]="frmAutorizaciones">

      <div class="form-container row">


        <div class="col-8">
          <div class="row">


            <div class="col-12 col-md-6 col-lg-3">
              <mat-form-field style="width: 100%">
                <mat-label>Tipo de identificación</mat-label>
                <mat-select formControlName="tipoDoc">
                  <mat-option *ngFor="let t of tiposDoc" [value]="t.codigo">
                    {{ t.label }}
                  </mat-option>
                </mat-select>

                <mat-error *ngIf="getControl['tipoDoc']?.hasError('required')">
                  Tipo de documento es obligatorio
                </mat-error>
              </mat-form-field>
            </div>


            <div class="col-12 col-md-6 col-lg-3">
              <mat-form-field style="width: 100%">
                <mat-label>Número de identificación</mat-label>
                <input matInput formControlName="numDoc" maxlength="20" />

                <mat-error *ngIf="getControl['numDoc']?.hasError('required')">
                  Número de documento es obligatorio
                </mat-error>

                <mat-error *ngIf="getControl['numDoc']?.hasError('noSpaces')">
                  No se permiten espacios
                </mat-error>

                <mat-error *ngIf="getControl['numDoc']?.hasError('maxlength')">
                  Máximo 20 caracteres
                </mat-error>
              </mat-form-field>
            </div>


            <div class="col-12 col-md-6 col-lg-3">
              <mat-form-field style="width: 100%">
                <mat-label>Número de radicación</mat-label>
                <input matInput formControlName="numSolicitud" maxlength="20" />
              </mat-form-field>
            </div>


            <div class="col-12 col-md-6 col-lg-3">
              <mat-form-field style="width: 100%">
                <mat-label>Estado</mat-label>
                <mat-select formControlName="estado">
                  <mat-option *ngFor="let e of estados" [value]="e.value">
                    {{ e.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>


            <div class="col-12 col-md-6 col-lg-4">
              <mat-form-field style="width: 100%">
                <mat-label>Fecha de radicación</mat-label>

                <mat-date-range-input [rangePicker]="picker">
                  <input matStartDate formControlName="fechaInicio" placeholder="Fecha inicio" />
                  <input matEndDate formControlName="fechaFin" placeholder="Fecha fin" />
                </mat-date-range-input>

                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>

                <mat-error *ngIf="hasError(getControl['fechaInicio']) || hasError(getControl['fechaFin'])">
                  Debe seleccionar fecha inicial y final
                </mat-error>
              </mat-form-field>
            </div>

          </div>
        </div>


        <div class="col-4">
          <div class="row">

            <div class="col-12 col-md-6 col-lg-7">
              <button type="button" class="btn btn-primary btn-icon" [disabled]="frmAutorizaciones.invalid || isLoading"
                (click)="consultar()"
                appTrackClick
                [trackData]="trackDataConsulta"
                >
                <mat-icon>search</mat-icon><span>CONSULTAR</span>
              </button>
            </div>

            <div class="col-12 col-md-6 col-lg-5">
              <button type="button" class="btn btn-primary btn-icon" (click)="limpiar()">
                <mat-icon>cancel</mat-icon><span>LIMPIAR</span>
              </button>
            </div>

          </div>
        </div>

      </div>
    </form>


    <div *ngIf="haveResponse && !isLoading">

      <div class="mat-elevation-z8 col-12" [ngClass]="{ 'hide-table': !haveDataToShow }">

        <div class="table-scroll">
          <table mat-table [dataSource]="dsAutorizaciones" matSort matSortActive="fecha" matSortDirection="desc"
            matSortDisableClear *ngIf="haveResponse">

            <ng-container matColumnDef="fecha">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha de radicación</th>
              <td mat-cell *matCellDef="let e">
                {{ e.fecha | date:'dd/MM/yyyy HH:mm' }}
              </td>
            </ng-container>

            <ng-container matColumnDef="radicado">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Número de radicación</th>
              <td mat-cell *matCellDef="let e">{{ e.radicado }}</td>
            </ng-container>

            <ng-container matColumnDef="estado">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Estado</th>
              <td mat-cell *matCellDef="let e">
                <span class="estado-chip" [ngClass]="{
                  'estado-finalizada': e.estado === 'FINALIZADA',
                  'estado-tramite': e.estado === 'EN TRAMITE'
                }">
                  {{ e.estado }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="tipoDoc">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo de documento</th>
              <td mat-cell *matCellDef="let e">{{ e.tipoDoc }}</td>
            </ng-container>

            <ng-container matColumnDef="numDoc">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Número de documento</th>
              <td mat-cell *matCellDef="let e">{{ e.numDoc }}</td>
            </ng-container>

            <ng-container matColumnDef="nombre">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre del usuario</th>
              <td mat-cell *matCellDef="let e">{{ e.nombre }}</td>
            </ng-container>

            <ng-container matColumnDef="ciudad">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Ciudad de radicación</th>
              <td mat-cell *matCellDef="let e">{{ e.ciudad }}</td>
            </ng-container>

            <ng-container matColumnDef="celular">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Celular</th>
              <td mat-cell *matCellDef="let e">{{ e.celular }}</td>
            </ng-container>

            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Correo</th>
              <td mat-cell *matCellDef="let e">{{ e.email }}</td>
            </ng-container>


            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let e">
                <button mat-icon-button matTooltip="Bitácora" (click)="abrirBitacora(e)">
                  <mat-icon>menu_book</mat-icon>
                  </button>
                  <button mat-icon-button matTooltip="Reenviar soportes médicos" (click)="confirmarReenvio(e)" appTrackClick [trackData]="trackDataReenvio">
                    <mat-icon>forward_to_inbox</mat-icon>
                  </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

          </table>
        </div>
        <mat-paginator [pageSize]="10" [pageSizeOptions]="[10]" showFirstLastButtons>
        </mat-paginator>
      </div>
      <div style="text-align: center" *ngIf="!haveDataToShow && generalMessage">
        <span class="message-span">
          {{ generalMessage }}
        </span>
      </div>
    </div>
    <div *ngIf="!haveResponse" class="message-container">
      <span class="message-span">
        COMPLETE LOS CAMPOS PARA CONSULTAR
      </span>
    </div>

  </div>
</div>